import { CardClickEventData } from '../../../../new-lib/types/common';
import { injectComponentBetweenRows } from '../../../../helpers/common';
import LaunchesBannerContainer from '../../../entity/launch/components/LaunchesBanner/LaunchesBannerContainer';
import CompoundLaunchCard from '../../../entity/launch/components/mobile/CompoundLaunchCard';
import { useSelector } from 'react-redux';
import CardUIListType2 from '../../../../new-components/cards/CardUIListType2';
import LaunchesBannerWrapper from '../../../entity/launch/components/LaunchesBanner/LaunchesBannerWrapper';
import { useRouter } from 'next/router';
import GridCard from '../../../../new-components/cards/GridCard';
import { EntityTypes } from '../../../../new-lib/constants/common';
import CompoundGridCard from '../../../../new-components/cards/CompoundGridCard';
import GetAppBanner from '../../../../new-components/GetAppBanner';

interface MapSearchResultsToCardsProps {
  searchResults: object[];
  findType: string;
  pageNumber?: number;
  searchLocation: string;
  launches?: any;
  compoundLaunches?: any;
  viewType?: 'list' | 'grid';
  activeTab?: string;
}

const MapSearchResultsToCards = ({
  searchResults,
  findType,
  searchLocation,
  launches,
  compoundLaunches,
  viewType,
  activeTab
}: MapSearchResultsToCardsProps): JSX.Element => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { asPath, query } = useRouter();
  const isNawyNow = asPath.includes('nawy-now');
  const pageNumber = query['page_number']
    ? parseInt(query['page_number']?.toString())
    : undefined;
  const getCompoundCard = (result: any, clickEventData: CardClickEventData) => {
    return isNawyNow ? (
      <GridCard
        entity={result}
        key={result.id}
        clickEventData={clickEventData}
        cardPosition={clickEventData.index}
        entityType={EntityTypes.COMPOUND}
      />
    ) : (
      <CompoundGridCard
        entity={result}
        key={result.id}
        clickEventData={clickEventData}
        cardPosition={clickEventData.index}
        entityType={EntityTypes.COMPOUND}
      />
    );
  };
  const getPropertyCard = (
    viewType: 'list' | 'grid' | undefined,
    result: any,
    clickEventData: CardClickEventData
  ) => {
    if (viewType == 'list') {
      return (
        <CardUIListType2
          property={result}
          key={result.id}
          clickEventData={clickEventData}
          cardPosition={clickEventData.index}
        />
      );
    } else {
      return (
        <GridCard
          entity={result}
          key={result.id}
          clickEventData={clickEventData}
          cardPosition={clickEventData.index}
          entityType={EntityTypes.PROPERTY}
        />
      );
    }
  };

  const getResultType = (result: any, index: number): JSX.Element => {
    const clickEventData: CardClickEventData = {
      eventAction: isNawyNow
        ? 'nawy_now_property_click'
        : findType == 'compound'
          ? 'cmpnd_click'
          : 'prop_click',
      eventLocation: searchLocation,
      index: index,
      ...(findType == 'compound' && { compound: result }),
      ...(findType == 'property' && { property: result }),
      cardPageNumber: pageNumber,
      compound: findType === 'compound' ? result : result.compound,
      area: result.area,
      developer: result.developer,
      propertyType: result.property_type,
      featureName: findType,
      price: result.min_price
    };

    if (findType === 'compound') {
      return getCompoundCard(result, clickEventData);
    }

    return getPropertyCard(viewType, result, clickEventData);
  };
  const mappedResults =
    isMobile && compoundLaunches
      ? injectComponentBetweenRows(
          searchResults.map((result, index) => getResultType(result, index)),
          compoundLaunches.map((launch: any, index: number) => (
            <CompoundLaunchCard
              launch={launch}
              key={launch.id}
              position={index + 1}
            />
          )),
          1
        )
      : searchResults?.map((result, index) => getResultType(result, index));

  const getCards = () => {
    return isMobile ? getMobileCards() : getDesktopCards();
  };
  const getDesktopCards = () => {
    return pageNumber == 1 || pageNumber == undefined
      ? injectComponentBetweenRows(
          mappedResults,
          asPath === '/search' && (
            <LaunchesBannerWrapper
              key={launches[0]?.id}
              className="launches-banner-wrapper"
            >
              <LaunchesBannerContainer launches={launches} />
            </LaunchesBannerWrapper>
          ),
          3
        )
      : mappedResults;
  };

  const getMobileCards = () => {
    return injectComponentBetweenRows(
      mappedResults,
      asPath === '/search' ? (
        <LaunchesBannerWrapper className="launches-banner-wrapper">
          <LaunchesBannerContainer launches={launches} />
        </LaunchesBannerWrapper>
      ) : (
        asPath.includes('/compound') && activeTab === 'all' && <GetAppBanner />
      ),
      1
    );
  };

  return <>{searchResults ? getCards() : null}</>;
};

export default MapSearchResultsToCards;
